/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext, useRef, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Arrow from "~components/svg/Arrow";
import Cross from "~components/svg/Cross";

import illustration from "~assets/images/newsletter-illustration.svg";

const Newsletter = ({ modal }) => {
  const { newsletterModalActive, setNewsletterModalActive } = useContext(
    AppContext
  );
  const { device } = useContext(DocumentContext);

  const submitRef = useRef();

  const [email, setEmail] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  //

  const { allDataYaml } = useStaticQuery(graphql`
    query Newsletter {
      allDataYaml {
        edges {
          node {
            newsletterMessage
          }
        }
      }
    }
  `);

  let newsletterMessage;

  if (allDataYaml?.edges?.[0]) {
    allDataYaml.edges.forEach(({ node }) => {
      if (!newsletterMessage && node?.newsletterMessage) {
        ({ newsletterMessage } = node);
      }
    });
  }

  //

  const submitProxy = e => {
    e.preventDefault();

    if (submitRef?.current) {
      submitRef.current.click();
    }

    return false;
  };

  const onSubmit = e => {
    e.preventDefault();

    if (
      typeof window !== `undefined` &&
      window.location.href.includes(`localhost:8000`)
    ) {
      setSubmitting(true);

      setTimeout(() => {
        setSubmitting(false);
        setSubmitted(true);
      }, 3000);

      return false;
    }

    if (
      submitting ||
      submitted ||
      !process.env.GATSBY_NETLIFY_FUNCTIONS ||
      !process.env.GATSBY_MAILCHIMP_API_KEY ||
      !process.env.GATSBY_MAILCHIMP_LIST_ID
    ) {
      return false;
    }

    setSubmitting(true);

    const mailchimpData = {
      email
    };

    fetch(`${process.env.GATSBY_NETLIFY_FUNCTIONS}/mailchimp`, {
      body: JSON.stringify(mailchimpData),
      method: `POST`
    })
      .then(response => {
        // eslint-disable-next-line no-console
        console.log(`[mailchimp]: `, response);

        setSubmitting(false);
        setSubmitted(true);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });

    return false;
  };

  //

  let fontSize = modal ? `b1` : `f5`;

  if (device && device === `mobile`) {
    fontSize = `b1`;
  }

  //

  return (
    <section
      className={`newsletter w-full relative z-10 ${
        modal
          ? `modal pt-20 md:pt-0`
          : `pt-12 md:pt-24 px-6 md:px-0 pb-12 sm:pb-24 bg-dark-green`
      } text-cream`}
    >
      <div className="grid">
        <div
          className={`grid-end-12 sm:grid-end-8 sm:grid-start-3 relative ${
            modal && newsletterModalActive ? `pointer-events-auto` : ``
          } ${
            modal ? `pt-12 px-8 md:px-20 pb-10 md:pb-20 bg-light-green` : ``
          }`}
        >
          {modal && (
            <button
              type="button"
              className="absolute top-0 right-0 z-20 mt-2 sm:mt-4 mr-2 sm:mr-5 p-2"
              onClick={() => setNewsletterModalActive(false)}
            >
              <Cross className="w-8" color="dark-green" />
            </button>
          )}

          <figure className="w-full sm:w-2/3 relative mx-auto sm:px-10">
            <img
              className="w-full relative block"
              src={illustration}
              alt="Mushroom friends"
            />
          </figure>

          <p className={`w-full mt-10 text-center ${fontSize}`}>
            {newsletterMessage ||
              `Sign up for occasional news, tasty treats and random acts of kindness. We promise not to be bothersome.`}
          </p>

          <form
            className={`${
              submitting || submitted ? `opacity-50` : ``
            } w-full relative mt-8`}
            onSubmit={onSubmit}
          >
            <input
              ref={submitRef}
              className="w-0 h-0 opacity-0 pointer-events-none"
              type="submit"
            />

            <input
              className="w-full h-12 relative block f5 text-center"
              onChange={e => setEmail(e.currentTarget.value)}
              placeholder="Enter your email"
              type="email"
            />

            <div className="h-full absolute top-0 right-0 bottom-0 flex items-end justify-center">
              <button
                className="newsletter__button w-12 h-12 relative block"
                onClick={submitProxy}
                type="button"
              >
                <div className="w-full h-full relative flex items-center justify-center pointer-events-none">
                  <Arrow
                    className="newsletter__arrow w-4 md:w-6 pointer-events-none"
                    color={modal ? `dark-green` : `orange`}
                    direction=">"
                  />
                </div>
              </button>
            </div>
          </form>

          <p
            className={`transition-opacity ${
              submitted ? `` : `opacity-0`
            } mt-6 b1 text-center text-${modal ? `white` : `orange`}`}
          >
            Thanks!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
